export abstract class PairIterator<T>{

    protected iterator: number = -1;

    protected arr: Array<Array<T>> = [];

    private data: Array<T>;


    constructor(_data){
        this.data = _data;
        this.arr = this.toArray();
    }


    next(): Array<T>{
        this.iterator = this.iterator < 0 ? 0 : this.iterator + 2;
        return this.current();
    }

    current(): Array<T>{
        if(this.iterator === -1){
            return null;
        }
        let cur = typeof this.data[this.iterator] !== 'undefined' ? this.data[this.iterator] : null;
        let next = typeof this.data[this.iterator + 1] !== 'undefined' ? this.data[this.iterator + 1] : null;
        if(cur === null && next === null){
            this.iterator = -1;
            return null;
        }
        return [cur, next];
    }

    length(): number{
        return Math.ceil(this.data.length/2);
    }

    index(): number{
        return this.iterator;
    }

    first(): Array<T>{
        let prevIterator = this.iterator;
        this.iterator = -1;
        let res = this.current();
        this.iterator = prevIterator;
        return res;
    }
    last(): Array<T>{
        let prevIterator = this.iterator;
        this.iterator = this.length() - 1;
        let res = this.current();
        this.iterator = prevIterator;
        return res;
    }

    asArray(): Array<Array<T>>{
        return this.arr;
    }

    /**
     *
     * @returns {Array<Array<T>>}
     */
    toArray(): Array<Array<T>>{
        let res = [];
        this.iterator = -1;
        for(let i = 0; i < this.length(); i++){
            res.push(this.next());
        }
        return res;
    }
}


// WEBPACK FOOTER //
// ./src/app/utils/pair.iterator.ts